import React from 'react';
import { Link } from 'react-router-dom';
import { useMode } from './DarkMode';

export default function Navbar() {
  const { toggleMode } = useMode();

  return (
    <div className='Navbar'>
      <nav className='navbar navbar-expand-lg navbar-dark bg-dark'>
        <div className='container-fluid'>
          <Link className='navbar-brand' to='/'>
            <strong>Todo-List</strong>
          </Link>
          <button
            className='navbar-toggler'
            type='button'
            data-bs-toggle='collapse'
            data-bs-target='#navbarSupportedContent'
            aria-controls='navbarSupportedContent'
            aria-expanded='false'
            aria-label='Toggle navigation'
          >
            <span className='navbar-toggler-icon'></span>
          </button>
          <div className='collapse navbar-collapse' id='navbarSupportedContent'>
            <ul className='navbar-nav me-auto mb-2 mb-lg-0'>
              <li className='nav-item active'>
                <Link className='nav-link ' aria-current='page' to='/'>
                  <strong>Home</strong>
                </Link>
              </li>
              <li className='nav-item active'>
                <Link className='nav-link' to='/about'>
                  <strong>About</strong>
                </Link>
              </li>
              <li className='nav-item active'>
                <Link className='nav-link' to='/contact'>
                  <strong>Contact</strong>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className='form-check form-switch mx-3'>
          <input
            className='form-check-input'
            onClick={toggleMode}
            type='checkbox'
            role='switch'
            id='flexSwitchCheckDefault'
          />
        </div>
      </nav>
    </div>
  );
}
